"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobModalCard = void 0;
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var store_1 = require("../../store");
var tag_icon_1 = require("../tag.icon/tag.icon");
var CSS = {
    container: 'c-JobCard',
    chip: 'c-JobCard--Chip',
    readonly: 'c-JobCard--ReadOnly',
    content: 'c-JobCard__Content',
    icon: 'c-JobCard__Icon',
    name: 'c-JobCard__Name'
};
var Style = (_a = {},
    _a[CSS.container] = {
        display: 'flex',
        'align-items': 'center',
        cursor: 'pointer',
        'text-align': 'left',
        'line-height': theme_1.DefaultTheme.space(4)
    },
    _a[CSS.chip] = {
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'border-radius': theme_1.DefaultTheme.space(6)
    },
    _a[CSS.icon] = {
        'margin-right': theme_1.DefaultTheme.space(1),
        height: '32px',
        width: '32px'
    },
    _a[CSS.name] = {
        'margin-right': theme_1.DefaultTheme.space(3)
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.JobModalCard = {
    viewCard: function (ctx, content) {
        var summary = store_1.AppStore.TagSummary.get(ctx.tag.objectId);
        return (0, mithril_1.m)('div', { className: CSS.container, onclick: ctx.action }, [
            (0, mithril_1.m)('div', { className: CSS.icon }, tag_icon_1.TagIcon.view(ctx.tag, summary)),
            (0, mithril_1.m)('div', { className: CSS.content }, [
                (0, mithril_1.m)('span', content != null ? content : ctx.tag.name)
            ])
        ]);
    },
    viewChip: function (ctx) {
        var summary = store_1.AppStore.TagSummary.get(ctx.tag.objectId);
        return (0, mithril_1.m)('div', { className: "".concat(CSS.container, " ").concat(CSS.chip) }, [
            (0, mithril_1.m)('div', { className: CSS.icon }, tag_icon_1.TagIcon.view(ctx.tag, summary)),
            (0, mithril_1.m)('div', { className: CSS.name }, ctx.tag.name),
            image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, { onclick: ctx.cancel })
        ]);
    }
};
//# sourceMappingURL=job.card.js.map